import React, { useEffect, useState } from 'react';
import './App.less';
import bg from "./assets/bg.jpg";
import avatar from "./assets/avatar.png";
import finger from "./assets/finger.png";
import age from "./assets/age.png";
import device from 'current-device'

declare var isMobile: Function;
declare var isIPhone8: Function;
declare var parseUrlParams: Function;
declare var wakeupOrInstall: Function;

function App() {
    const [nickname, setNickname] = useState("邀请者：-");

    useEffect(() => {
        const params = parseUrlParams();
        if (params.name) {
            setNickname("邀请者：" + params.name);
        } else {
            setNickname("邀请者：-");
        }
    }, []);

    function onClickDownload() {
        wakeupOrInstall();
    }

    function mTop() {
        if (!isMobile()) {
            return 560;
        } else {
            return 840 / 750 * window.innerWidth;
        }
    }

    function mBottom() {
        if (!isMobile()) {
            return 755;
        } else {
            return 1145 / 750 * window.innerWidth;
        }
    }

    return (
        <div className="App" style={{ height: device.tablet() ? "140vh" : (isIPhone8() ? "110vh" : "100vh") }}>
            <img className="App-bg" src={bg} alt="" />

            <div className="App-top">
                <img className="App-top-avatar" src={avatar} alt="" />
                <div className="App-top-nickname">{nickname}</div>
            </div>

            <div className="App-age">
                <img className="App-age-img" src={age} alt="" />
            </div>

            <div className="App-middle" style={{top: mTop()}} >
                <div className="App-middle-downloadButton" onClick={onClickDownload}>
                    <img className="App-middle-downloadButton-finger" src={finger} alt="" />
                </div>
            </div>

            <div className="App-bottom" style={{top: mBottom()}}>
                <div className="info">温馨提示：</div>
                <ul>
                    <li className="info">若您未被邀请成功，请回到该界面重新接受邀请。</li>
                    <li className="info">为了确保您在游戏中能成功被玩家邀请，推荐使用非手机自带浏览器下载或唤醒游戏。</li>
                    <li className="info">实物奖励仅邀请者可领取，数量有限先到先得哟!</li>
                    <li className="info">图片仅供参考，实体卡包中卡牌随机分配，具体以实物说明为准。</li>
                </ul>

                <div className="App-bottom-corporation">运营单位：深圳市创梦天地科技有限公司</div>
            </div>
        </div>
    );
}

export default App;
